<ion-header>
  <ion-toolbar class="ion-text-center">
    <ion-title class="ion-text-left"></ion-title>

    <ion-buttons slot="end">
      <ion-button fill="clear" (click)="close(false)">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div class="form-container">
    <h3 class="message">Please enter the password of</h3>

    <p class="email">{{ auth.Email }}</p>

    <form class="formGroup" [formGroup]="formGroup" (ngSubmit)="authenticate()" (keyup.enter)="authenticate()">
      <ion-item *ngIf="!defaultEmail" class="email-input" [disabled]="authenticating">
        <ion-label position="floating">Email</ion-label>
        <ion-input type="text" formControlName="email" autofocus="true" clearInput="true" inputmode="email"></ion-input>
      </ion-item>

      <ion-item class="password-input" [disabled]="authenticating">
        <ion-label position="floating">Password</ion-label>
        <ion-input
          type="password"
          formControlName="password"
          autofocus="true"
          clearInput="true"
          inputmode="email"
        ></ion-input>
      </ion-item>

      <div #btnContainer class="btn-container">
        <ion-button
          class="hub-btn"
          type="submit"
          shape="round"
          size="large"
          [disabled]="formGroup.invalid || authenticating"
          >Continue</ion-button
        >
        <ion-button class="hub-btn resetPassword" fill="clear" size="small" (click)="forgotPassword($event)"
          >Forgot Password?</ion-button
        >
      </div>
    </form>

    <p *ngIf="message" class="errorMessage">
      {{ message }}
    </p>
  </div>
  <ion-progress-bar *ngIf="authenticating" color="primary" type="indeterminate"></ion-progress-bar>
</ion-content>
